'use strict';
/**
 *  Load modules
 */

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { CountUp } from 'countup.js';
import jBox from 'jbox';
import '../scss/app.scss';
$(document).ready(function () {
  var browserWidth = window.innerWidth || document.documentElement.clientWidth; // Get User Geolocation

  var userLatitude = 43.856316,
      // default latitude
  userLongitude = -79.508538; // default longitude

  function getGeolocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(setPosition, showError);
    } else {
      console.log('The Browser Does not Support Geolocation');
    }
  }

  ;

  function setPosition(position) {
    userLatitude = position.coords.latitude;
    userLongitude = position.coords.longitude;
  }

  function showError(error) {
    if (error.PERMISSION_DENIED) {
      console.log('The User have denied the request for Geolocation.');
    }
  }

  getGeolocation(); // drow map

  var officess_location;

  function drowMap() {
    officess_location = [];
    var circleStyle = {};

    if (browserWidth >= 1440) {
      circleStyle = {
        'circle-radius': 20,
        'circle-stroke-width': 12
      };
    } else if (browserWidth >= 1024) {
      circleStyle = {
        'circle-radius': 15,
        'circle-stroke-width': 8
      };
    } else if (browserWidth >= 768) {
      circleStyle = {
        'circle-radius': 15,
        'circle-stroke-width': 8
      };
    } else {
      circleStyle = {
        'circle-radius': 10,
        'circle-stroke-width': 4
      };
    }

    $('.search__item').each(function (index) {
      var office_lat = $(this).data('lat'),
          office_long = $(this).data('long'),
          office_id = $(this).data('id');

      if (office_lat && office_long) {
        officess_location.push({
          'type': 'Feature',
          'id': office_id,
          'properties': {
            'id': office_id
          },
          'geometry': {
            'type': 'Point',
            'coordinates': [office_long, office_lat]
          }
        });
      }
    });

    if (officess_location.length > 0) {
      userLongitude = officess_location[0].geometry.coordinates[0];
      userLatitude = officess_location[0].geometry.coordinates[1];
    }

    var mapZoom = browserWidth >= 640 ? 11 : 9;
    mapboxgl.accessToken = 'pk.eyJ1IjoiZXRyYWNrcyIsImEiOiJjbDEyYWlxcTUycWhyM2RtdTFjeHI4N2NqIn0.DQKeitKeQ1D5nQ4AiJqoJw';
    var map = new mapboxgl.Map({
      container: 'map',
      // container ID
      style: 'mapbox://styles/etracks/cl14t9o4n000514nz7kgpar0k',
      // style URL
      center: [userLongitude, userLatitude],
      // starting position [lng, lat]
      zoom: mapZoom,
      // starting zoom
      attributionControl: false,
      pitchWithRotate: false
    });
    map.addControl(new mapboxgl.NavigationControl({
      showCompass: false
    }), 'bottom-right');
    map.loadImage('/wp-content/themes/etracks/assets/src/icons/map-point.png', function (error, image) {
      if (error) throw error;
      map.addImage('map-point', image);
    });
    map.on('load', function () {
      map.addSource('point', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': officess_location
        },
        cluster: true,
        'clusterRadius': 40
      });
      map.addLayer({
        'id': 'points',
        'type': 'symbol',
        'source': 'point',
        'layout': {
          'icon-image': 'map-point',
          'icon-anchor': 'bottom',
          'icon-size': 0.9
        }
      });
      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'point',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#27A83B',
          'circle-radius': circleStyle['circle-radius'],
          'circle-stroke-width': circleStyle['circle-stroke-width'],
          'circle-stroke-color': '#fff',
          'circle-stroke-opacity': 0.9
        }
      });
      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'point',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        },
        paint: {
          'text-color': '#ffffff'
        }
      });
      map.on('click', 'clusters', function (e) {
        var features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        var clusterId = features[0].properties.cluster_id;
        map.getSource('point').getClusterExpansionZoom(clusterId, function (err, zoom) {
          if (err) return;
          map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom
          });
        });
      }); // Change the cursor to a pointer when the mouse is over the places layer.

      map.on('mouseenter', 'points', function (e) {
        map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', 'points', function (e) {
        map.getCanvas().style.cursor = '';
      });
      map.on('mouseenter', 'clusters', function () {
        map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', 'clusters', function () {
        map.getCanvas().style.cursor = '';
      });
      map.on('click', 'points', function (e) {
        var features = map.queryRenderedFeatures(e.point, {
          layers: ['points']
        });

        if (!features.length) {
          return;
        }

        var feature = features[0];
        $('.jBox-Modal .search-results .search__item').each(function () {
          if ($(this).data('id') != feature.properties.id) {
            $(this).removeClass('active');
          } else {
            var elementTop = document.getElementById('search__item-' + $(this).data('id')).offsetTop,
                divTop = document.getElementById('search-results').offsetTop,
                elementRelativeTop = elementTop - divTop - 16;
            $('.search-results').animate({
              scrollTop: elementRelativeTop
            }, 700);
            $(this).addClass('active');
          }
        });
      });
      $('.search__item').on('click', function (e) {
        map.flyTo({
          center: [$(this).data('long'), $(this).data('lat')],
          zoom: 18
        });
        $('.search__item').removeClass('active');
        $(this).addClass('active');
      });
    });
  } // default data


  var enteredAddress = '',
      businessRoleCode; // set businessRoleCode

  $(".recycle-tires-btn").click(function (e) {
    businessRoleCode = $(this).data('business-role-code');
  }); //search

  var $searchInput = $('#search-input'),
      $searchButton = $("#btn-search");
  $searchButton.attr('disabled', true);
  $searchInput.on('input', function () {
    if ($(this).val().trim().length != 0) {
      $searchButton.attr('disabled', false);
    } else {
      $searchButton.attr('disabled', true);
    }
  });
  $searchButton.click( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              $searchInput.blur();
              enteredAddress = $searchInput.val().trim() + ' Canada';
              _context.next = 5;
              return showData();

            case 5:
              drowMap();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()); // show esrp data

  var $searchLoader = $('.search-loader'),
      $searchResults = $('.search-results'),
      $searchError = $('.search-error');
  var excludeRegNumbers = ['3000100', '2007046', '2007027', '3000098', '2006850', '3000085'];

  function showSearchData(data) {
    $searchResults.html('');
    var items = data.map(function (item, index) {
      if (excludeRegNumbers.find(function (el) {
        return el === (item === null || item === void 0 ? void 0 : item.regNumber);
      })) {} else {
        var _item$address, _item$address2, _item$address3;

        var firstAddressLine = item !== null && item !== void 0 && (_item$address = item.address) !== null && _item$address !== void 0 && _item$address.firstAddressLine ? "".concat(item.address.firstAddressLine, ", ") : '';
        var secondAddressLine = item !== null && item !== void 0 && (_item$address2 = item.address) !== null && _item$address2 !== void 0 && _item$address2.secondAddressLine ? "".concat(item.address.secondAddressLine, ", ") : '';
        var postalOrZip = item !== null && item !== void 0 && (_item$address3 = item.address) !== null && _item$address3 !== void 0 && _item$address3.postalOrZip ? "".concat(item.address.postalOrZip) : '';
        return "<div class=\"search__item\" data-id=\"".concat(index, "\" id=\"search__item-").concat(index, "\" data-long=\"").concat(item.address.longitude, "\" data-lat=\"").concat(item.address.latitude, "\">\n                            <div class=\"search__item-title\">").concat((item === null || item === void 0 ? void 0 : item.displayName) || '', "</div>\n                            <div class=\"search__item-regNumber\">").concat((item === null || item === void 0 ? void 0 : item.regNumber) || '', "</div>\n                            <div class=\"search__item-text\">").concat(firstAddressLine).concat(secondAddressLine).concat(postalOrZip, "</div>\n                            <a href=\"tel:").concat((item === null || item === void 0 ? void 0 : item.phone) || '', "\" class=\"search__item-phone\">").concat((item === null || item === void 0 ? void 0 : item.phone) || '', "</a><br>\n                            <a href=\"http://maps.google.com/maps?q=").concat(encodeURIComponent(firstAddressLine + secondAddressLine + postalOrZip), "&sll=").concat(item.address.latitude, ",").concat(item.address.longitude, "\" target=\"_blank\" class=\"search__item-link\">Directions</a>\n                        </div>");
      }
    });
    $searchResults.append(items);
  }

  function showServerError(err) {
    $searchError.text(err.message).show();
    $searchLoader.hide();
  }

  function showData() {
    return _showData.apply(this, arguments);
  }

  function _showData() {
    _showData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var requestData, response, json, _json;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              $searchResults.html('');
              $searchLoader.show();
              requestData = {
                "skip": 0,
                "limit": 100,
                "distance": 20000,
                "businessRoleCode": businessRoleCode
              };

              if (enteredAddress) {
                requestData.address = enteredAddress;
              } else {
                requestData.geoLocation = {
                  "latitude": userLatitude,
                  "longitude": userLongitude
                };
              }

              _context3.next = 6;
              return fetch('https://portal-appgateway.etrackssrp.com/companies/nearestCompanies', {
                method: 'POST',
                headers: {
                  'accept': '*/*',
                  'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(requestData)
              });

            case 6:
              response = _context3.sent;

              if (!response.ok) {
                _context3.next = 17;
                break;
              }

              _context3.next = 10;
              return response.json();

            case 10:
              json = _context3.sent;
              $searchError.html('').hide();
              $searchLoader.hide();
              showSearchData(json);
              json.length ? '' : $searchError.html('No data found').show();
              _context3.next = 21;
              break;

            case 17:
              _context3.next = 19;
              return response.json();

            case 19:
              _json = _context3.sent;
              showServerError(_json);

            case 21:
              return _context3.abrupt("return", response);

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _showData.apply(this, arguments);
  }

  ; //jBox Modal with Map

  new jBox('Modal', {
    content: $('#recycleTiresModal'),
    attach: '.recycle-tires-btn.collector',
    getTitle: 'data-title',
    closeButton: 'title',
    isolateScroll: false,
    onOpen: function () {
      var _onOpen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return showData();

              case 2:
                drowMap();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onOpen() {
        return _onOpen.apply(this, arguments);
      }

      return onOpen;
    }(),
    onOpenComplete: function onOpenComplete() {
      drowMap();
    },
    onClose: function onClose() {
      enteredAddress = '';
      officess_location = [];
      $searchInput.val('');
      $searchButton.attr('disabled', true);
      $searchError.html('').hide();
      $searchResults.html('');
      userLatitude = 43.856316;
      userLongitude = -79.508538;
      getGeolocation();
    }
  }); //jBox Haulers Modal

  var $searchableProFormControl = $('.searchable-pro-form-control'),
      $searchableProSubmitSearch = $('.searchable-pro-submit-search'),
      $searchableProResults = $('.searchable-pro-results');
  $searchableProSubmitSearch.attr('disabled', true);
  $searchableProFormControl.on('input', function () {
    if ($(this).val().trim().length != 0) {
      $searchableProSubmitSearch.attr('disabled', false);
    } else {
      $searchableProSubmitSearch.attr('disabled', true);
    }
  });
  new jBox('Modal', {
    content: $('#haulersModal'),
    attach: '.recycle-tires-btn.hauler',
    getTitle: 'data-title',
    closeButton: 'title',
    isolateScroll: false,
    onOpen: function onOpen() {},
    onClose: function onClose() {
      $searchableProFormControl.val('');
      $searchableProSubmitSearch.attr('disabled', true);
      $searchableProResults.html('');
    }
  });
  $searchableProSubmitSearch.click(function (e) {
    $searchableProFormControl.blur();
  }); //Statistic Counter

  function startCounter(el) {
    var options = {
      useEasing: true,
      useGrouping: true,
      separator: ",",
      decimal: ".",
      suffix: "",
      enableScrollSpy: true
    };
    var value = $(el).html().replace(',', '');
    var numberType = 0;

    Number.isInteger = Number.isInteger || function (value) {
      return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
    };

    if (Number.isInteger(Number(value))) {
      numberType = 0;
    } else {
      numberType = 1;
    }

    var counterNumbersAnimation = new CountUp(el, value, numberType, 3, options);
    counterNumbersAnimation.start();
  }

  $('.counter-number').each(function (el) {
    startCounter(this);
  });

  if ($('.statistic').length > 0) {
    var setStatisticSlider = function setStatisticSlider() {
      statisticSlider.slick({
        dots: true,
        arrows: false,
        swipe: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true
      });
    };

    var statisticSlider = $(".statistic");

    if (browserWidth < 768) {
      setStatisticSlider();
    }

    $(window).on('resize orientationchange', function () {
      browserWidth = window.innerWidth || document.documentElement.clientWidth;

      if (browserWidth < 768) {
        if ($('.statistic:not(.slick-slider)').length > 0) {
          setStatisticSlider();
        }
      } else {
        if ($('.statistic.slick-slider').length > 0) {
          statisticSlider.slick('unslick');
        }
      }
    });
  } //redirect after contact form submit


  $('#wpcf7-f312-o1 .wpcf7-form-control.btn').on('click', function (e) {
    var submitInterval = setInterval(function () {
      if ($('#wpcf7-f312-o1 .wpcf7-form').hasClass('custom-sent')) {
        window.location.replace('https://etracks.ca/thank-you/');
        clearInterval(submitInterval);
      }

      setTimeout(function () {
        clearInterval(submitInterval);
      }, 5000);
    }, 500);
  });
});